import { SoccerIncidentId } from '@collector/sportsapi-client-legacy'

import { AddIncidentConfig } from '../../configuration'

export const addIncidentConfig: AddIncidentConfig<SoccerIncidentId> = {
  scoreIncidents: [SoccerIncidentId.Goal],
  missedIncidents: [SoccerIncidentId.ShotOffTarget],
  attemptIncidents: [SoccerIncidentId.ShotOnTarget],
  stoppedIncidents: [SoccerIncidentId.ShotBlocked],
}
